module.exports = __webpack_public_path__ + "static/media/29DUNON3.224be4f0.jpg";